<template>
<div class="mask" v-show="showStatus" @touchmove.stop.prevent="disabledTouchMove">
	<div v-for="i in step" @click="nextStep" v-show="i===curr">
		<slot :name="'step-'+i"></slot>
	</div>
</div>
</template>

<script>
export default {
	props: {
		showStatus: {
			type: Boolean
			, default: true
		}
		, step: {
			type: Number
			, default: 1
		}
	}
	, data: function(){
		return {
			curr: 1
		};
	}
	, methods: {
		nextStep: function(){
			this.curr++;

			if( this.curr === this.step ){
				this.showStatus = false;
				this.$dispatch('stepComplete');
			}
		}
		, disabledTouchMove(){}
	}
};
</script>

<style lang="scss">
.mask{
	z-index: 10;
}
</style>